<template>
  <div class="customer-wrp">
    <div class="title">客户信息</div>
    <DetailForm :detailList="infoList" :detailData="data" />
    <div class="title address-title">
      客户收件地址
      <i class="iconfont" @click="addNewAddress">&#xe61f;</i>
    </div>
    <Address v-for="(item, index) in dataSource" :key="index" :dataSource="item" :editorLink='`/customer/address/edit?id=${item.id}&merchantId=${item.merchantId}`' />
  </div>
</template>

<script>
import {
  Row,
  Col
} from 'vant'
import { customerRequest } from '@services'
import Address from '@components/Address/index.vue'
import DetailForm from '@components/DetailForm/index.vue'
export default {
  data () {
    return {
      data: {
      },
      isDefault: true,
      infoList: [
        {
          label: '客户名称',
          field: 'company'
        },
        {
          label: '客户税号',
          field: 'taxNo'
        },
        {
          label: '地址、电话',
          field: 'address',
          multi: true
        },
        {
          label: '银行、账号',
          field: 'bankName',
          multi: true
        }
      ],
      dataSource: [
      ]
    }
  },
  mounted () {
    this.getDetail(this.$route.params.id)
  },
  computed: {
  },
  methods: {
    async getDetail (id) {
      const detail = await customerRequest.customer.detail({ merchantId: id })
      if (detail.success) {
        this.data = detail.result.merchantArchivesVo
        this.dataSource = detail.result.addresseeInfoResponseList
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    addNewAddress () {
      this.$router.push(`/customer/address/add?merchantId=${this.data.id}`)
    }
  },
  components: {
    Address,
    DetailForm,
    [Row.name]: Row,
    [Col.name]: Col

  }
}
</script>

<style lang="less" scoped src="./style.less"/>
